import { Alert, Slide, Snackbar } from "@material-ui/core";

export default function MiUiSnackbar({
  toggleSnackbar,
  open,
  message,
  severity,
}) {
  const SlideTransition = (props) => {
    return <Slide {...props} direction="down" />;
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={toggleSnackbar}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      TransitionComponent={SlideTransition}
      style={{
        top: "130px",
      }}
    >
      {severity === "success" ? (
        <Alert
          onClose={toggleSnackbar}
          severity={severity}
          sx={{
            width: "100%",
            border: "2px solid var(--stroke-button-success-default, #43A35C)",
            color: "#43A35C",
            fontSize: "16px",
            lineHeight: "24px",
            fontFamily: "Red Hat Text",
          }}
        >
          {message}
        </Alert>
      ) : (
        <Alert
          onClose={toggleSnackbar}
          severity={severity}
          sx={{
            width: "100%",
            border: "2px solid var(--stroke-button-danger-default, #C54443)",
            color: "#A83939",
            fontSize: "16px",
            lineHeight: "24px",
            fontFamily: "Red Hat Text",
          }}
        >
          {message}
        </Alert>
      )}
    </Snackbar>
  );
}
